import { Radio, RadioGroupProps } from 'antd';
import styled from 'styled-components';

export const StyledRadioGroup = styled(Radio.Group)<RadioGroupProps>`
  .ant-radio-label {
    font-weight: 400;
    font-size: 16px;
    color: ${props => props.theme.colors.secondary.main.text};
  }
  .ant-radio-inner {
    width: 24px;
    height: 24px;
    border: 2px solid ${props => props.theme.colors.secondary.main.text};
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    transition: all 0.3s ease;
  }

  .ant-radio-inner::after {
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    content: '';
    border: 2px solid ${props => props.theme.colors.neutral.light.contentBg};
    transition: all 0.3s ease;
  }

  .ant-radio-checked .ant-radio-inner {
    background-color: ${props => props.theme.colors.primary.main.filled};
    border-color: ${props => props.theme.colors.primary.main.filled};
  }

  .ant-radio-checked .ant-radio-inner::after {
    background-color: ${props => props.theme.colors.primary.main.filled};
    transform: scale(1);
  }
  .ant-radio-checked + .ant-radio-label {
    color: ${props => props.theme.colors.primary.main.filled};
  }

  .ant-radio-disabled .ant-radio-inner {
    border-color: ${props => props.theme.colors.neutral.light.text} !important;
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
  }

  .ant-radio-disabled + .ant-radio-label {
    color: ${props => props.theme.colors.neutral.light.text};
  }
`;
